import { initUrl } from '@/config/axios_config'

/*****************系统API********************* */
//获取当前用户信息
export const getCurrentUserInfo = data => initUrl(`/rest/system/currentUserInfo`, data, 'GET')

// 获取系统名称
export const getSystemName = data => initUrl(`/rest/system/systemName`, { ...(data || {}), _t: Date.now() }, 'GET')

export const getDictsByCode = data => initUrl(`/rest/dict/listDictsByCode`, data, 'GET')

/**
 * 文件上传
 * @param {*} data file文件 
 * @returns 
 */
export const uploadFile = data => initUrl('/rest/file/uploadFile', data, 'POST')

/**
 * 将base照片转为url照片
 * @param {*} data base64 url 
 * @returns 
 */
export const uploadFileBase64ToImage = data => initUrl('/rest/file/uploadBase64ToImage', data, 'POST')
/**
 * 新增app管理
 * @param {*} data base64 url 
 * @returns 
 */
export const addAppInfo = data => initUrl('/appInfo/add', data, 'POST')
/**
 * 获取透视图表的数据
 * @param {*} 
 * @returns 
 */
export const getWebDataRock = data => initUrl('/reportPatient/getWebDataRock', data, 'GET')



// WEBPACK FOOTER //
// ./src/api/systemApi.js